<template>
    <div class="row">
        <div class="col-sm-12 col-lg-12">
            <div class="card product-widget">
                <div class="card-body" v-if="trades.length === 0">
                    <h4 class="card-title text-center">There are no trades for this offer yet</h4>
                </div>

                <div class="card-body" v-if="trades.length > 0">
                    <h4 class="card-title">Trades associated with this offer</h4>
                    <h5 class="card-subtitle">These are trades counterparties have sent for this offer</h5>

                    <div class="product d-flex align-items-center p-t-20 p-b-20"
                         v-for="(trade,index) in trades" v-bind:key="index"
                         v-bind:class="{'border-bottom': index < trades.length - 1}">
                        <blockie :address="getCounterpartyEmail(trade)" :width="64" class="product-image m-r-20"></blockie>
                        <div class="product-detail">
                            <h5>{{getCounterpartyName(trade)}}</h5>
                            <span class="font-15 text-muted">Submitted for approval on 5 April 2017</span>
                            <h4 class="font-20 font-bold text-dark-green m-t-30">{{trade.unit_price | money}} / {{trade.units}}</h4>
                        </div>
                        <div class="product-action ml-auto m-b-5 align-self-end">
                            <button class="btn btn-success">Approve</button>
                            <button class="btn btn-outline-secondary">Decline</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Blockie from "../../../common/Blockie";

    export default {
        name: "OfferTrades",
        props: {
            offer: Object
        },
        components: {Blockie},
        data() {
            return {
                trades: []
            }
        },
        mounted() {
            this.getTrades();
        },
        methods: {
            getTrades() {
                this.$http
                .get("/offers/" + this.offer.offer_id + "/trades")
                .then(reply => {
                    this.trades = reply.data;
                });
            },
            getCounterpartyEmail(trade) {
                return trade.user_id === trade.buyer_id ? trade.seller_email : trade.buyer_email;
            },
            getCounterpartyName(trade) {
                return trade.user_id === trade.buyer_id ? trade.seller_first_name + " " + trade.seller_last_name:
                trade.buyer_first_name + " " + trade.buyer_last_name;
            }
        }
    }
</script>

<style scoped>

</style>
